import { cn, typography } from "@/utilities/tailwind-utils";

interface CardSubHeaderProps {
  title: string;
  className?: string;
  as?: "h3" | "h4" | "h5" | "h6";
}

export function CardSubHeader({ 
  title, 
  className, 
  as: Component = "h3" 
}: CardSubHeaderProps) {
  return (
    <div className={cn(typography.cardSubHeader, className)}>
      <Component className={cn(typography.cardSubHeaderTitle)}>
        {title}
      </Component>
    </div>
  );
}
